import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useTabContext } from "../context/context";

const Amenities = ({ isPremium, setPremiumChangesMade }) => {
  const { amenitiesList, setAmenitiesChecked, commonAreasList, setCommonAreasChecked, isReferral, filteredShowAmenities, filteredShowCommonAreas } = useTabContext();

  const { control } = useFormContext();

  return (
    <div className={`provider-section`}>
      <h3>Additional Information</h3>
      {isReferral ? (
        <div></div>
      ) : (
        <>
          {/* Amenities Section */}
          <div className="mt-4 grid grid-cols-1 items-center gap-4 pt-4">
            <div className="font-semibold">Amenities:</div>
            {filteredShowAmenities ? (
              <div>
                {amenitiesList.map(amenity => {
                  const amenityId = parseInt(amenity.id, 10);
                  return (
                    <Controller
                      key={amenity.id}
                      name={`amenities.${amenityId}`}
                      control={control}
                      defaultValue={false}
                      render={({ field }) => (
                        <div className="hover:cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md bg-gray-50 border-r border-b border-gray-200 mb-2">
                          <label className="hover:cursor-pointer flex items-center mb-0" htmlFor={`amenities_${amenityId}`}>
                            <input
                              {...field}
                              type="checkbox"
                              onChange={e => {
                                field.onChange(e);
                                setPremiumChangesMade(true);
                                if (e.target.checked) {
                                  setAmenitiesChecked(prev => [...prev, amenityId]);
                                } else {
                                  setAmenitiesChecked(prev => prev.filter(item => item !== amenityId));
                                }
                              }}
                              checked={field.value}
                              className="ml-0 mr-2 hover:cursor-pointer"
                              id={`amenities_${amenityId}`}
                            />
                            {amenity.name}
                          </label>
                        </div>
                      )}
                    />
                  );
                })}
              </div>
            ) : (
              <div>Your services do not display any amenities</div>
            )}
          </div>

          {/* Common Areas Section */}
          <div className="mt-4 grid grid-cols-1 items-center gap-4 pt-4">
            <div className="font-semibold">Common Areas:</div>
            {filteredShowCommonAreas ? (
              <div>
                {commonAreasList.map(commonArea => {
                  const commonAreaId = parseInt(commonArea.id, 10);
                  return (
                    <Controller
                      key={commonArea.id}
                      name={`common_areas.${commonAreaId}`}
                      control={control}
                      defaultValue={false}
                      render={({ field }) => (
                        <div className="hover:cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md bg-gray-50 border-r border-b border-gray-200 mb-2">
                          <label className="hover:cursor-pointer flex items-center mb-0" htmlFor={`common_areas_${commonAreaId}`}>
                            <input
                              {...field}
                              type="checkbox"
                              onChange={e => {
                                field.onChange(e);
                                setPremiumChangesMade(true);
                                if (e.target.checked) {
                                  setCommonAreasChecked(prev => [...prev, commonAreaId]);
                                } else {
                                  setCommonAreasChecked(prev => prev.filter(item => item !== commonAreaId));
                                }
                              }}
                              checked={field.value}
                              className="ml-0 mr-2 hover:cursor-pointer"
                              id={`common_areas_${commonAreaId}`}
                            />
                            {commonArea.name}
                          </label>
                        </div>
                      )}
                    />
                  );
                })}
              </div>
            ) : (
              <div>Your services do not display any common areas</div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Amenities;
